// component
import {
  Home as HomeIcon, BugReport as BugReportIcon, ManageAccounts as ManageAccountsIcon, Category as CategoryIcon, Quiz as QuizIcon, ContactSupport as ContactSupportIcon,
  Assessment as AssessmentIcon,
  Summarize as SummarizeIcon,
  ShoppingCart as ShoppingCartIcon,
  CalendarMonth as CalendarMonthIcon,
  HelpCenter,
  Payment as PaymentIcon,
  AccountBalance as RoyaltyIcon,
  Receipt as InvoiceIcon, Autorenew as StatusIcon,
  Forest as PlantationIcon, Group as StakeHolderMappingIcon,
  BrowserUpdated as ResourceUpdateIcon, ManageAccounts as ManageIcon,
  Folder as FolderIcon, MonetizationOn as MonetizationOnIcon, PersonAdd as PersonAdd
} from '@mui/icons-material';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import LanIcon from '@mui/icons-material/Lan';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DashboardIcon from '@mui/icons-material/Dashboard';
// import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import BadgeIcon from '@mui/icons-material/Badge';
// import AssessmentIcon from '@mui/icons-material/Assessment';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import {
  DEMAND_ROLES,
  QUALITY_ROLES,
  RESOURCE_ROLES,
  PAYMENT_ROLES,
  HELPDESK_ROLES,
  PIT_ROLES,
  ROLES, STAKEHOLDERTYPE, STAKEHOLDERSUBTYPE
} from '../../../../common/constants';
import ReportIcon from '@mui/icons-material/Report';
import { t } from 'i18next';

// ----------------------------------------------------------------------



export const navConfig = [
  /*=============================== Admin Module =====================*/
  {
    role: 'Admin',
    modules: [
      {
        title: 'Dashboard',
        path: '/sidebar/adminDashboard',
        icon: <HomeIcon />,
      },
      {
        title: 'Helpdesk',
        path: 'helpDeskDashboard',
        icon: <HelpCenter />,
        children: [
          {
            title: 'home',
            path: '/helpDeskDashboard/helpDeskDashboard',
            icon: <HomeIcon />,
          },
          {
            title: 'requests',
            path: '/helpDeskDashboard/requests',
            icon: <ReportIcon />,
          },
          {
            title: 'reports',
            path: '/helpDeskDashboard/reports',
            icon: <BugReportIcon />,
          },
          {
            title: 'Manage SLA',
            path: '/helpDeskDashboard/manage-category',
            icon: <CategoryIcon />,
          },
          {
            title: 'Manage FAQ',
            path: '/helpDeskDashboard/manage-faq',
            icon: <QuizIcon />,
          },
          {
            title: 'FAQs',
            path: '/helpDeskDashboard/faqs',
            icon: <ContactSupportIcon />,
          },
          {
            title: 'Manage Helpdesk User',
            path: '/helpDeskDashboard/manage-helpdesk-user',
            icon: <ManageAccountsIcon />,
          },
          {
            title: 'Manage Holiday List',
            path: '/helpDeskDashboard/holiday-list',
            icon: <CalendarMonthIcon />,
          }

        ]
      },
      {
        title: "PIT",
        path: '/asnGRNChipping',
        icon: <CalendarMonthIcon />,
        children: [
          {
            title: 'ASN',
            path: '/asnGRNChipping',
            icon: <AssessmentIcon />,
          },
          {
            title: 'LLE PickUp/Tracker',
            path: '/inventoryType',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Actual Plant Consumption',
            path: '/plantCBConsumption',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Expected Plant Consumption',
            path: '/plantconsumption',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Consolidated Weekly Plans',
            path: '/plantSchedule',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Inventory Ledger',
            path: '/LnvLedger',
            icon: <AssessmentIcon />,
          },
        ]
      },
      {
        title: "Quality",
        path: '/qualitydashboard/home',
        icon: <SummarizeIcon />,
        children: [
          {
            title: 'home',
            path: '/qualitydashboard/home',
            icon: <HomeIcon />,
          },
          {
            title: 'Manage Tolerance Limit',
            path: '/qualitydashboard/managetolerance',
            icon: <ManageAccountsIcon />,
          },
          {
            title: 'Inspection Work Order',
            path: '/qualitydashboard/inspectionworkorder',
            icon: <CategoryIcon />,
          },
          {
            title: 'Issue & ATC',
            path: '/qualitydashboard/issueatc',
            icon: <QuizIcon />,
          },


        ]
      },
      {
        title: 'Registration',
        path: '/sidebar/onboardingStakeholders',
        icon: <AssessmentIcon />,
        children: [
          {
            title: 'Onboarding Users',
            path: '/sidebar/onboardingStakeholders',
            icon: <PersonAdd />,
          }
        ]
      },
    ]
  },
  /*=============================== ResourceModule =====================*/
  {
    role: RESOURCE_ROLES.SuperAdmin,
    modules: [
      {
        title: 'Knowledge Management',
        path: '/resourcedashboard/plantScmKnowledgeManagement',
        icon: <HomeIcon />,
      },
      {
        title: 'Resource Update',
        path: '/resourcedashboard/searchByURN',
        icon: <HomeIcon />,
      }
    ]
  },
  {
    role: RESOURCE_ROLES.PlantSCMMember,
    modules: [
      {
        title: 'home',
        path: '/resourcedashboard/home',
        icon: <HomeIcon />,
      },
      {
        title: 'StakeHolder Mapping',
        path: '/resourcedashboard/adminhome',
        icon: <StakeHolderMappingIcon />,
        children: [
          {
            title: 'Add Stakeholder Mapping',
            path: '/resourcedashboard/selectStakeHolder',
            icon: <HomeIcon />,
          },
          {
            title: 'Grower-HIT Stakeholder Mapping',
            path: '/resourcedashboard/growerHitMapping',
            icon: <HomeIcon />,
          },
          {
            title: 'Transporter Stakeholder Mapping',
            path: '/resourcedashboard/selectTransporterStakeholder',
            icon: <HomeIcon />,
          },
          {
            title: 'View Transporter Mapping Routes',
            path: '/resourcedashboard/viewTransporterMappingRoutes',
            icon: <HomeIcon />,
          }
        ]
      },
      {
        title: 'Knowledge Management',
        path: '/resourcedashboard/plantScmKnowledgeManagement',
        icon: <FolderIcon />,
      },
      {
        title: 'Rate Card',
        path: '/resourcedashboard/rateCard',
        icon: <MonetizationOnIcon />,
      },
      {
        title: 'Plantation',
        path: '/resourcedashboard/plantationHome',
        icon: <PlantationIcon />,
      },
      {
        title: 'Resource Update',
        path: '/resourcedashboard/searchByURN',
        icon: <ResourceUpdateIcon />,
      },
      {
        title: 'Manage LOV',
        path: '/resourcedashboard/adminhome',
        icon: <ManageIcon />,
        children: [
          {
            title: 'Manage Plantation LOV',
            path: '/resourcedashboard/managePlantationLOV ',
            icon: <ManageIcon />,
          }
        ]
      },
      {
        title: 'Constraints Manage',
        path: '/resourcedashboard/adminhome',
        icon: <ShoppingCartIcon />,
        children: [
          {
            title: 'LLE/IS Storage Capacity   ',
            path: '/resourcedashboard/storageCapacity',
            icon: <SummarizeIcon />,
          }
        ]
      }
    ]

  },
  {
    role: RESOURCE_ROLES.ModuleIncharge,
    modules: [
      {
        title: 'home',
        path: '/resourcedashboard/home',
        icon: <HomeIcon />,
      },
      {
        title: 'Manage LOV',
        path: '/resourcedashboard/adminhome',
        icon: <ManageIcon />,
        children: [
          {
            title: 'Plantation',
            path: '/resourcedashboard/managePlantationLOV ',
            icon: <ManageIcon />,
          }
        ]
      },
    ]
  },
  {
    role: RESOURCE_ROLES.FinanceUser,
    modules: [
      {
        title: 'Resource',
        path: '/resourcedashboard/adminhome',
        icon: <ManageIcon />,
        children: [
          {
            title: 'home',
            path: '/resourcedashboard/home',
            icon: <HomeIcon />,
          },
          {
            title: 'Plantation Manage LOV',
            path: '/resourcedashboard/managePlantationLOV ',
            icon: <ManageIcon />,
          }
        ]
      },
      {
        title: 'Payment',
        path: '/paymentDashboard/advancePayment',
        icon: <RoyaltyIcon />,
        children: [
          {
            title: 'Advance Payment',
            path: '/paymentDashboard/advancePayment',
            icon: <PaymentIcon />,
          },
          {
            title: 'Royalty Payment',
            path: '/paymentDashboard/royaltyPayment',
            icon: <RoyaltyIcon />,
          },
          {
            title: 'Invoice Payment',
            path: '/paymentDashboard/invoicePayment',
            icon: <InvoiceIcon />,
          },
          {
            title: 'Payment Status',
            path: '/paymentDashboard/PaymentStatusABRPLUser',
            icon: <StatusIcon />,
          }
        ]
      }
    ]
  },
  {
    role: RESOURCE_ROLES.ResourceScrutinizer,
    modules: [
      {
        title: 'home',
        path: '/resourcedashboard/home',
        icon: <HomeIcon />,
      },
      {
        title: 'Manage LOV',
        path: '/resourcedashboard/adminhome',
        icon: <ManageIcon />,
        children: [
          {
            title: 'Plantation',
            path: '/resourcedashboard/managePlantationLOV ',
            icon: <ManageIcon />,
          }
        ]
      },
    ]
  },
  // {
  //   role: RESOURCE_ROLES.SuperAdmin,
  //   modules : [ 
  //     {
  //     title: 'home',
  //     path: '/resourcedashboard/home',
  //     icon: <HomeIcon />,
  //   },
  //     {
  //       title: 'Resource Update',
  //       path: '/resourcedashboard/searchByURN',
  //       icon: <ResourceUpdateIcon />,
  //     },
  //     {
  //       title: 'Manage LOV',
  //       path: '/resourcedashboard/adminhome',
  //       icon: <ManageIcon />,
  //       children : [
  //         {
  //           title: 'Plantation',
  //           path: '/resourcedashboard/managePlantationLOV ',
  //           icon: <ManageIcon />,
  //         }
  //       ]
  //     },
  //   ]

  // }


  /*=============================== Demand Module =====================*/
  {
    role: DEMAND_ROLES.DemandPlanner,
    modules: [
      {
        title: 'Configure Annual Planning',
        path: '/demandDashboard/yearlyInput',
        icon: <HomeIcon />,
      },
      {
        title: 'Configure Monthly Data',
        path: '/demandDashboard/monthlyPlanning',
        icon: <CalendarMonthIcon />,
        children: [
          {
            title: 'Shortlist Stakeholder',
            path: '/demandDashboard/monthlyPlanning',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Monthly Mapping',
            path: '/demandDashboard/monthlyMapping',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Monthly Allocation',
            path: '/demandDashboard/monthlyAllocation',
            icon: <AssessmentIcon />,
          },
        ]
      },
      {
        title: 'Manage Constraints',
        path: '/demandDashboard',
        icon: <ShoppingCartIcon />,
        children: [
          {
            title: 'Stakeholder MBR',
            path: '/demandDashboard/manageMbr',
            icon: <SummarizeIcon />,
          },
          {
            title: 'LLE Chipping Capacity',
            path: '/demandDashboard/lleChippingCapacity',
            icon: <SummarizeIcon />,
          },
          {
            title: 'LLE Annual Harvesting Potential',
            path: '/demandDashboard/lleAnnualHarvestingPotential',
            icon: <SummarizeIcon />,
          },
          {
            title: 'Safety Stock Pile',
            path: '/demandDashboard/safetyStockPile',
            icon: <SummarizeIcon />,
          },
        ]
      },
    ]
  },
  {
    role: DEMAND_ROLES.DemandModuleIncharge,
    modules: [
      {
        title: 'Configure Monthly Data',
        path: '/demandDashboard/monthlyPlanning',
        icon: <CalendarMonthIcon />,
        children: [
          {
            title: 'Monthly Allocation',
            path: '/demandDashboard/monthlyAllocation',
            icon: <AssessmentIcon />,
          },
        ]
      },
      {
        title: 'Manage Constraints',
        path: '/demandDashboard',
        icon: <ShoppingCartIcon />,
        children: [
          {
            title: 'Stakeholder MBR',
            path: '/demandDashboard/mbrWorkflow',
            icon: <SummarizeIcon />,
          },
        ]
      },
    ]

  },
  {
    role: DEMAND_ROLES.ProcessingIncharge,
    modules: [
      {
        title: 'Demand',
        path: '/demandDashboard/monthlyPlanning',
        icon: <AssessmentIcon />,
        children: [
          {
            title: 'Monthly Allocation',
            path: '/demandDashboard/monthlyAllocation',
            icon: <AssessmentIcon />,
          },
        ]
      },
      {
        title: "PIT",
        path: '/asnGRNChipping',
        icon: <CalendarMonthIcon />,
        children: [
          {
            title: 'ASN',
            path: '/asnGRNChipping',
            icon: <AssessmentIcon />,
          },
          {
            title: 'LLE PickUp/Tracker',
            path: '/inventoryType',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Actual Plant Consumption',
            path: '/plantCBConsumption',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Expected Plant Consumption',
            path: '/plantconsumption',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Consolidated Weekly Plans',
            path: '/plantSchedule',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Inventory Ledger',
            path: '/LnvLedger',
            icon: <AssessmentIcon />,
          },
        ]
      },
    ]
  },
  {
    role: DEMAND_ROLES.ProcurementLead,
    modules: [
      {
        title: 'Configure Monthly Data',
        path: '/demandDashboard/monthlyPlanning',
        icon: <CalendarMonthIcon />,
        children: [
          {
            title: 'Monthly Allocation',
            path: '/demandDashboard/monthlyAllocation',
            icon: <AssessmentIcon />,
          },
        ]
      },
    ]
  },
  {
    role: 'Stakeholder',
    modules: [
      {
        title: 'Stakeholder Confirmation',
        path: '/demandDashboard/workflowStatus',
        icon: <CalendarMonthIcon />,
      },
    ]
  },

  /*=============================Helpdesk Module==================*/

  {
    role: HELPDESK_ROLES.HelpdeskAdminUser,
    modules: [

      {
        title: 'home',
        path: '/helpDeskDashboard/helpDeskDashboard',
        icon: <HomeIcon />,
      },
      {
        title: 'requests',
        path: '/helpDeskDashboard/requests',
        icon: <ReportIcon />,
      },
      {
        title: 'reports',
        path: '/helpDeskDashboard/reports',
        icon: <BugReportIcon />,
      },
      {
        title: 'Manage SLA',
        path: '/helpDeskDashboard/manage-category',
        icon: <CategoryIcon />,
      },
      {
        title: 'Manage FAQ',
        path: '/helpDeskDashboard/manage-faq',
        icon: <QuizIcon />,
      },
      {
        title: 'FAQs',
        path: '/helpDeskDashboard/faqs',
        icon: <ContactSupportIcon />,
      },
      {
        title: 'Manage Helpdesk User',
        path: '/helpDeskDashboard/manage-helpdesk-user',
        icon: <ManageAccountsIcon />,
      },
      {
        title: 'Manage Holiday List',
        path: '/helpDeskDashboard/holiday-list',
        icon: <CalendarMonthIcon />,
      }


    ]
  },
  {
    role: HELPDESK_ROLES.HelpdeskAssistant,
    modules: [
      {
        title: 'requests',
        path: '/helpDeskDashboard/requests',
        icon: <ReportIcon />,
      },
      {
        title: 'FAQs',
        path: '/helpDeskDashboard/faqs',
        icon: <ContactSupportIcon />,
      }
    ]
  },
  {
    role: HELPDESK_ROLES.HelpdeskSupportExecutive,
    modules: [
      {
        title: 'requests',
        path: '/helpDeskDashboard/requests',
        icon: <ReportIcon />,
      },
      {
        title: 'FAQs',
        path: '/helpDeskDashboard/faqs',
        icon: <ContactSupportIcon />,
      }
    ]
  },
  {
    role: HELPDESK_ROLES.HelpdeskTeamMember,
    modules: [
      {
        title: 'requests',
        path: '/helpDeskDashboard/requests',
        icon: <ReportIcon />,
      },
      {
        title: 'FAQs',
        path: '/helpDeskDashboard/faqs',
        icon: <ContactSupportIcon />,
      }
    ]
  },

  {
    role: HELPDESK_ROLES.Guest,
    modules: [
      {
        title: 'requests',
        path: '/helpDeskDashboard/requests',
        icon: <ReportIcon />,
      },
      {
        title: 'FAQs',
        path: '/helpDeskDashboard/faqs',
        icon: <ContactSupportIcon />,
      }
    ]
  },

  /*=============================== Quality Module =====================*/
  {
    role: QUALITY_ROLES.QualityModuleIncharge,
    modules: [
      {
        title: 'home',
        path: '/qualitydashboard/home',
        icon: <HomeIcon />,
      },
      // {
      //   title: 'Manage Tolerance Limit',
      //   path: '/qualitydashboard/managetolerance',
      //   icon: <ManageAccountsIcon />,
      // },
      {
        title: 'Inspection Work Order',
        path: '/qualitydashboard/inspectionworkorder',
        icon: <CategoryIcon />,
      },
      {
        title: 'Issue & ATC',
        path: '/qualitydashboard/issueatc',
        icon: <QuizIcon />,
      },
      {
        title: 'Manage Worklist',
        path: '/qualitydashboard/manageWorkList',
        icon: <BugReportIcon />,
      },
    ]

  },
  {
    role: QUALITY_ROLES.Inspector,
    modules: [
      {
        title: 'home',
        path: '/qualitydashboard/home',
        icon: <HomeIcon />,
      },
      {
        title: 'Inspection Work Order',
        path: '/qualitydashboard/inspectionworkorder',
        icon: <CategoryIcon />,
      },
      {
        title: 'Issue & ATC',
        path: '/qualitydashboard/issueatc',
        icon: <QuizIcon />,
      },


    ]

  },
  {
    role: QUALITY_ROLES.ScmUser,
    modules: [
      {
        title: 'home',
        path: '/qualitydashboard/home',
        icon: <HomeIcon />,
      },
      {
        title: 'Manage Tolerance Limit',
        path: '/qualitydashboard/managetolerance',
        icon: <ManageAccountsIcon />,
      },
    ]
  },

  /*=============================== Payment Module =====================*/
  {
    role: PAYMENT_ROLES?.SCMEndUser,
    modules: [
      {
        title: 'Advance Payment',
        path: '/paymentDashboard/advancePayment',
        icon: <PaymentIcon />,
      },
      {
        title: 'Royalty Payment',
        path: '/paymentDashboard/royaltyPayment',
        icon: <RoyaltyIcon />,
      },
      {
        title: 'Payment Status',
        path: '/paymentDashboard/PaymentStatusABRPLUser',
        icon: <StatusIcon />,
      }
    ]
  },
  {
    role: PAYMENT_ROLES?.PaymentApprover,
    modules: [
      {
        title: 'Advance Payment',
        path: '/paymentDashboard/advancePayment',
        icon: <PaymentIcon />,
      },
      {
        title: 'Royalty Payment',
        path: '/paymentDashboard/royaltyPayment',
        icon: <RoyaltyIcon />,
      },

      {
        title: 'Payment Status',
        path: '/paymentDashboard/PaymentStatusABRPLUser',
        icon: <StatusIcon />,
      }
    ]
  },
    {
        role: PAYMENT_ROLES?.Updater,
        modules: [
            {
                title: 'Payment Status',
                path: '/paymentDashboard/PaymentStatusABRPLUser',
                icon: <StatusIcon />,
            }
        ]
    },
]

export const getNavConfigStakeholder = (stakeholderType, regStatus) => {
  const config = [

    {
      stakeholderType: STAKEHOLDERTYPE?.HIT,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,
        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/GhtSchedule',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AssessmentIcon />,
            },

            {
              title: "Consignment Pick-Up/Tracker",
              path: '/dashboardHome/ConsignmentPickUp',
              icon: <AssessmentIcon />,
            },
            {
              title: 'SO',
              path: '/dashboardHome/soList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AssessmentIcon />,
            },
            // {
            //   title: "GRN's",
            //   path: '/dashboardHome/grnList',
            //   icon: <AssessmentIcon />,
            // },
            {
              title: "Delivery Challans",
              path: '/dashboardHome/deliveryChalanList',
              icon: <AssessmentIcon />,
            },
            {
              title: "RB Challans",
              path: '/dashboardHome/rbChalanList',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            },
            {
              title: "SES",
              path: '/dashboardHome/sesList',
              icon: <AssessmentIcon />,
            },
            {
              title: "Generate Invoice",
              path: '/dashboardHome/generateInvoice',
              icon: <AssessmentIcon />,
            }
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetailsHit',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERTYPE?.Transporter,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: "Consignment Creation",
              path: '/dashboardHome/ChippingConsignmentCreation',
              icon: <AutoModeIcon />,
            },
            {
              title: "Pickup/Tracker",
              path: '/inventoryType',
              icon: <AutoModeIcon />,
            },
            //  {
            // title: "List of Vehicles",
            // // title: "Raise request for Unblock vehicles",
            // path: '/dashboardHome/listOfVehicles',
            // icon: <AutoModeIcon />
            // },
            {
              title: 'SO',
              path: '/dashboardHome/soList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "GRN's",
            //   path: '/grnList',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "Delivery Challans",
              path: '/dashboardHome/deliveryChalanList',
              icon: <AutoModeIcon />,

            },
            // {
            //   title: "Bidding Schedule Selection",
            //   path: '/dashboardHome/biddingSelection',
            //   icon: <AutoModeIcon />,
            // },

            // {
            //   title: "Bidding Schedule Approval",
            //   path: '/dashboardHome/biddingApproval',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "Add Bid",
              path: '/dashboardHome/bidding',
              icon: <AutoModeIcon />,
            },
            {
              title: "Bidding",
              path: '/dashboardHome/transporterAllBidding',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            },
            //  {
            //   title: 'Consignment Cancellation List',
            //   path: '/dashboardHome/consignmentCancellationList',
            //   icon: <AssessmentIcon />,
            // },
            {
              title: "SES",
              path: '/dashboardHome/sesList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Generate SES",
            //   path: '/dashboardHome/generateSes',
            //   icon: <AssessmentIcon />,
            // },
            {
              title: "Upload/Generate Invoice",
              path: '/dashboardHome/generateInvoice',
              icon: <AssessmentIcon />,
            },
            // {
            //   title: "Bidding Approval",
            //   path: '/dashboardHome/biddingApprovalList',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetailsTransporter',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERTYPE?.LLE,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.userOnboarding'),
          path: '/sidebar/onboardingStakeholders',
          icon: <PersonAdd />,
          order: 2,
        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 3,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 4,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 5,
          children: [
            // {
            //   title: 'STO',
            //   path: '/dashboardHome/StoList',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: 'SCO',
              path: '/dashboardHome/scoList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/lpiSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: 'Chipping Orders',
              path: '/dashboardHome/chippingOrders',
              icon: <AutoModeIcon />,
            },
            {
              title: "ASN's",
              path: '/dashboardHome/AsnGRn',
              icon: <AutoModeIcon />,
            },
            {
              title: "DBS ASN",
              path: '/dashboardHome/dbsAsn',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "ASN Correction",
            //   path: '/dashboardHome/asnCorrection',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "GRN's",
              path: '/dashboardHome/grnList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "GRN Approval",
            //   path: '/dashboardHome/grnApprove',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "LLE Pickup/Tracker",
              path: '/dashboardHome/inventoryType',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            {
              title: "Delivery Challans",
              path: '/dashboardHome/deliveryChalanList',
              icon: <AutoModeIcon />,
            },
            {
              title: "Inventory Ledger",
              path: '/dashboardHome/LnvLedger',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            },
            // {
            //   title: "SES",
            //   path: '/dashboardHome/sesList',
            //   icon: <AutoModeIcon />,
            // },
            // {
            //   title: "SES Approval",
            //   path: '/dashboardHome/sesApproval',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "Inventory Level",
              path: '/dashboardHome/inventoryLevel',
              icon: <AutoModeIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetailsLle',
          icon: <HowToRegIcon />,
          order: 7,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 8,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERTYPE?.InterimStorageOperator,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.userOnboarding'),
          path: '/sidebar/onboardingStakeholders',
          icon: <PersonAdd />,
          order: 2,
        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 3,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 4,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 5,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "STO",
              path: '/dashboardHome/stoList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/lpiSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: 'Chipping Orders',
              path: '/dashboardHome/chippingOrders',
              icon: <AutoModeIcon />,
            },
            {
              title: "ASN's",
              path: '/dashboardHome/asnGRN',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "GRN's",
            //   path: '/dashboardHome/grnList',
            //   icon: <AutoModeIcon />,
            // },
            // {
            //   title: "LLE RB Pickup/Tracker",
            //   path: '/dashboardHome/inventoryType',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "Dispacth Pickup/Tracker",
              path: '/dashboardHome/inventoryType',
              icon: <AutoModeIcon />,
            },
            {
              title: "Delivery Challans",
              path: '/dashboardHome/deliveryChalanList',
              icon: <AutoModeIcon />,
            },
            {
              title: "Inventory Ledger",
              path: '/dashboardHome/LnvLedger',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            }
          ]

        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetailsTempStorage',
          icon: <HowToRegIcon />,
          order: 7,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 8,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.INDIVIDUAL,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            }
          ]

        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
            {
              title: "Workflow",
              path: '/dashboardHome/workflowGrower',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.JFMC,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.GROWER,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.consignmentList'),
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            }
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.OTHER_GOV_AGENCY,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,
        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },

          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },

    {
      stakeholderType: STAKEHOLDERSUBTYPE.COOPERATIVE,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationMemberDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.FPO,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,
        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationMemberDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.FPC,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationMemberDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.SHG,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationMemberDetails',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },
    {
      stakeholderType: STAKEHOLDERSUBTYPE.FOREST,
      modules: [
        {
          title: t('sidebarStakeholder.dashboard'),
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,


        },
        {
          title: t('sidebarStakeholder.helpdesk'),
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children: [
            {
              title: t('sidebarStakeholder.requests'),
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.faqs'),
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: t('sidebarStakeholder.demand'),
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,

        },
        {
          title: t('sidebarStakeholder.pit'),
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children: [
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: t('sidebarStakeholder.po'),
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.weeklySchedule'),
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: t('sidebarStakeholder.invoices'),
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
          ]
        },
        {
          title: t('sidebarStakeholder.paymentStatus'),
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,

        },
        {
          title: t('sidebarStakeholder.registrationDetails'),
          path: '/dashboardHome/registrationDetailsForest',
          icon: <HowToRegIcon />,
          order: 6,

        },
        {
          title: t('sidebarStakeholder.resource'),
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children: [
            {
              title: t('sidebarStakeholder.viewKnowledgeManagement'),
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: t('sidebarStakeholder.plantationBatch'),
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
            {
              title: "RateCard Confirmation",
              path: '/dashboardHome/stakeholderRateApproval',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
    },

  ];
  // Apply filtering only for Transporter
  const matched = config.find(c => c.stakeholderType === stakeholderType);
  if (!matched) return [];

  if (stakeholderType === STAKEHOLDERTYPE?.Transporter && (regStatus !== 'Approved' && regStatus !== "ResourceUpdate_Initiated")) {
    const filteredModules = matched.modules.map(mod => ({
      ...mod,
      children: mod.children?.filter(child =>
        !['Add Bid'].includes(child.title)
      )
    }));
    return filteredModules;
  }

  return matched.modules;
}



